import React from "react";
import "./TicketLoader.css";

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-wrapper">
        <div className="loader"></div>
        <div className="loader-text">Raising your ticket, please wait...</div>
      </div>
    </div>
  );
};

export default Loader;
